// extracted by mini-css-extract-plugin
export default {"ShinyPlayer":"nQpU2e","shinyPlayer":"nQpU2e","icon":"ndA2rD","pausing":"ZhwkCv","playing":"Pmlnjw","mediaButton":"EZrC_l"};